import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'NoPermission.title',
    defaultMessage: 'Not Permitted',
  },
  areNotAllowed: {
    id: 'NoPermission.areNotAllowed',
    defaultMessage: "Sorry, you aren't allowed to access this page.",
  },
});



// WEBPACK FOOTER //
// ./components/pages/NoPermission/messages.js